import React from "react";
import { styled, Box, Container, SxProps } from "@mui/material";

export const FULL_TASK_SPLIT_LEFT_WIDTH = 1024;
export const FULL_TASK_SPLIT_RIGHT_WIDTH = 1024;

export interface FullTaskSplitProps {
  children?: React.ReactNode;
  sx?: SxProps;
  sxContainer?: SxProps;
  layout?: "1:1" | "1:6" | "1:4" | "1:3" | "1:2";
}

const divideLayout = (layout: "1:1" | "1:6" | "1:4" | "1:3" | "1:2" | undefined): number => {
  if (!layout) return 1;

  let split = layout.split(":");
  return parseInt(split[0]) / parseInt(split[1]);
};

const FullTaskSplit: React.FC<FullTaskSplitProps> = ({ layout = "1:1", sx = {}, sxContainer = {}, children }) => {
  return (
    <Wrapper sx={sx} layout={layout}>
      <Container sx={{ mt: 11, ...sxContainer }}>{children}</Container>
    </Wrapper>
  );
};

const Wrapper = styled(Box, { shouldForwardProp: (prop) => prop !== "layout" })<{
  layout: FullTaskSplitProps["layout"];
}>(({ theme, layout }) => ({
  alignSelf: "stretch",
  display: "flex",
  "&:first-of-type": {
    flex: layout === "1:1" ? 1 : divideLayout(layout),
    background: theme.palette.background.default,
    borderRight: `1px solid ${theme.palette.backgroundAlpha.border}`,
    ".MuiContainer-root": {
      ...(layout === "1:1" && { maxWidth: "100%" }),
      marginRight: 0,
    },
    [theme.breakpoints.up("lg")]: {
      ...(layout === "1:1" && { flex: 0.6 }),
    },
  },
  "&:last-of-type": {
    flex: layout === "1:1" ? 1 : 1 - divideLayout(layout),
    background: theme.palette.background.paper,
    ".MuiContainer-root": {
      ...(layout === "1:1" && { maxWidth: "100%" }),
      ...(layout === "1:6" && { maxWidth: 2136 }),
      ...(layout === "1:4" && { maxWidth: 1536 }),
      ...(layout === "1:3" && { maxWidth: 1236 }),
      ...(layout === "1:2" && { maxWidth: 836 }),
      marginLeft: 0,
    },
    [theme.breakpoints.up("lg")]: {
      ...(layout === "1:1" && { flex: 0.4 }),
    },
  },
  ...theme.helpers(theme).scrollBar,
  ...theme.helpers(theme).scrollableContainer,
}));

export default FullTaskSplit;
